import api from './api';

export const getOrCreateSubAccountService = () =>
  api(`/api/v1/iugu_get_or_create_subaccount/`, {
    method: 'post',
    data: {},
  });
